var exports = {
  "k": "x127c5a35--9ed537--container",
  "S": "x127c5a35--9ed537--image",
};

module.exports = exports;
